import { OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
var CountdownDialogComponent = /** @class */ (function () {
    function CountdownDialogComponent(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.title = data.TitleText || 'Please wait...';
        this.message = data.MessageText || '';
        this.oktext = data.OKText || '';
        this.canceltext = data.CancelText || '';
        this.maxtime = data.CountdownTime || 170;
        this.curtime = this.maxtime;
    }
    CountdownDialogComponent.prototype.CancelHandler = function () {
        // Disable timer, if possible
        if (this.timerHandle) {
            window.clearTimeout(this.timerHandle);
        }
        this.dialogRef.close(null);
    };
    CountdownDialogComponent.prototype.GetTimeString = function (timeval) {
        var result = Math.floor(timeval / 60) + ':' + ('00' + Math.floor(timeval % 60)).slice(-2);
        return result;
    };
    CountdownDialogComponent.prototype.ngOnInit = function () {
        this.time = 100;
        this.timerHandle = null;
        this.timeStr = '';
        // Initialize ticking to get it rolling
        this.Tick();
    };
    CountdownDialogComponent.prototype.OKHandler = function () {
        // Disable timer, if possible
        if (this.timerHandle) {
            window.clearTimeout(this.timerHandle);
        }
        this.dialogRef.close(true);
    };
    CountdownDialogComponent.prototype.Tick = function () {
        var _this = this;
        this.curtime--;
        if (this.curtime > 0) {
            this.time = Math.floor(this.curtime * 100 / this.maxtime);
            this.timeStr = this.GetTimeString(this.curtime);
            this.timerHandle = window.setTimeout(function () {
                _this.Tick();
            }, 1000);
        }
        else {
            // Close the dialog automatically as a "cancel"
            this.CancelHandler();
        }
    };
    return CountdownDialogComponent;
}());
export { CountdownDialogComponent };
var BaseCountdownDialogOptions = /** @class */ (function () {
    function BaseCountdownDialogOptions() {
    }
    return BaseCountdownDialogOptions;
}());
export { BaseCountdownDialogOptions };
